const renderedAvatarUserIdCounts = new Map<string, number>();
const membershipChangeListeners = new Set<() => void>();

const notifyMembershipChange = () => {
  for (const listener of membershipChangeListeners) {
    listener();
  }
};

const incrementRenderedAvatarUserId = (userId: string) => {
  const currentCount = renderedAvatarUserIdCounts.get(userId) ?? 0;
  renderedAvatarUserIdCounts.set(userId, currentCount + 1);

  if (currentCount === 0) {
    notifyMembershipChange();
  }
};

const decrementRenderedAvatarUserId = (userId: string) => {
  const currentCount = renderedAvatarUserIdCounts.get(userId);
  if (!currentCount) {
    return;
  }

  if (currentCount === 1) {
    renderedAvatarUserIdCounts.delete(userId);
    notifyMembershipChange();
    return;
  }

  renderedAvatarUserIdCounts.set(userId, currentCount - 1);
};

export const renderedAvatarUserIdsStore = {
  add(userId: string) {
    incrementRenderedAvatarUserId(userId);
  },

  getAll() {
    return [...renderedAvatarUserIdCounts.keys()];
  },

  has(userId: string) {
    return renderedAvatarUserIdCounts.has(userId);
  },

  remove(userId: string) {
    decrementRenderedAvatarUserId(userId);
  },

  /**
   * Subscribe to changes in the set of rendered avatar user ids (a key being
   * newly added or fully removed). Returns an unsubscribe function. Used by the
   * speaking-id assertion to clear stale mismatch reports once an off-view /
   * virtualized avatar mounts.
   */
  subscribe(listener: () => void) {
    membershipChangeListeners.add(listener);
    return () => {
      membershipChangeListeners.delete(listener);
    };
  },
};
